// extracted by mini-css-extract-plugin
export default {"link":"PaymentCancel_link__ArxBc","subtitle":"PaymentCancel_subtitle__dLONX","link_container":"PaymentCancel_link_container__PINIG"};